import React from 'react';
import AddEdit from '../../components/menu/add_edit/Component';

const Component = () => {
  return (
      <AddEdit componentTitle="Menus"/>
  )
}

export default Component
